const FormationsApi = [
    {
        id: 1,
        category: "formation",
        annee: "Digitale school of Paris, Vincennes, France Depuis octobre 2022",
        title : "Master Expert architecte digitale",
        desc: "M1 Consultant développeur web et mobile M2 Expert architecte digitale",
    },
    {
        id: 2,
        category: "formation",
        annee: "Université Paris 8, Saint-Denis, France De septembre 2019 à avril 2022",
        title : "Licence en informatique",
        desc: "Obtenue", 
    },
    {
        id: 3,
        category: "formation",
        annee: "Cours Diderot, Paris 11 Popincourt, France D'octobre 2018 à juin 2019",
        title : "BTS Service informatique aux organisations",
        desc: "1ère année",
    },
    {
        id: 4,
        category: "formation",
        annee: "Institut Supérieur des Etudes Technologiques de Djerba, Medenine, Tunisie De septembre 2017 à juin 2018",
        title : "Licence appliqué en informatique",
        desc: "L1",
    },
    {
        id: 5,
        category: "exprience",
        annee: "Cabinet Finance Assurance, Paris 16 D'octobre 2022 à septembre 2023",
        title : "Développeur full-stack en alternance",
        desc: "Conception et réalisation des landing page pour récupérer des contacts (nouveaux clients). Conception et réalisation d'un site web dynamique pour touts les programmes de nos partenaires (flux de données ,grande base de données). Technologie utilisée : HTML5,CSS3,PHP,JAVASCRIPT,BOOTSTRAP,SYMFONY,MYSQL",
    },
    {
        id: 6,
        category: "exprience",
        annee: "ETABLISSEMENTS MANOUKIAN, Paris 15 Vaugirard, France De mai 2019 à juin 2019" ,
        title : "Stage Développeur web",
        desc: "Études et implémentation d'un site web e-commerce Technologie utilisée : CMS WordPress", 
    },
    {
        id: 7,
        category: "exprience",
        annee: "Devclic, Tunis,Tunisie De janvier 2018 à février 2018",
        title : "Stage développeur web",
        desc: "Conception et réalisation d'un site web dynamique d'une salle de sport. Technologie utilisée : HTML5,CSS3,PHP,JAVASCRIPT,BOOTSTRAP", 
    },
]

export default FormationsApi